// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateProductDetailsStatusChangeModal = (name, value) =>

    dispatch => {

        if (name === 'isVisible') {

            addRemoveModalClass(value);

        }

        dispatch({
            name,
            type: actions.UPDATE_PRODUCT_DETAILS_STATUS_CHANGE_MODAL,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/product-detail-status-change-modal.js